export default class AcceptationUserPortailModal {
	constructor($scope, $state, $stateParams, ModalService, notification, $translate, _, $uibModal, UserRequestService) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this._ = _;
		this.$uibModal = $uibModal;
		this.UserRequestService = UserRequestService;
	}

	async $onInit() {
		this.loading = false;
		this.selectedSite;
		this.selectedReq = this.resolve.selectedReq;
		console.log(this.selectedReq);
		await this.getTypesClient();
	}

	async save() {
		if (this.selectedSite[0]) {
			this.selectedReq.idSite = this.selectedSite[0];
			this.ok();
		} else {
			this.notification.error('PORTAIL.USER.SITE_REQUIRED');
		}
	}

	async getTypesClient() {
		this.typesClient = await this.UserRequestService.getSitesClients();
		console.log(this.typesClient);
	}

	cancel() {
		this.dismiss();
	}

	ok() {
		this.close();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}

AcceptationUserPortailModal.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'ModalService',
	'notification',
	'$translate',
	'_',
	'$uibModal',
	'UserRequestService'
];
